import styled from 'styled-components';

const ResolvaIcon = styled.img`
  background-color: transparent;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
`;

export default ResolvaIcon;
